import React from 'react';
import { getMainLayerRenderSize } from '@/utils/layer-kit';
import { IImageLayerProps, ILayerProps } from '@/version-types';

const layerStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    overflow: 'visible',
    backfaceVisibility: 'hidden',
    pointerEvents: 'none',
    transformOrigin: '50% 50%',
    userSelect: 'none',
    perspective: 1000,
    transition: 'transform var(--smoothly-move-duration)',
};

const contentStyle: React.CSSProperties = {
    position: 'relative',
    overflow: 'inherit',
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
};

export const RenderWrapper: React.FC<{
    layer: ILayerProps;
    children?: React.ReactNode;
}> = ({ layer, children }) => {
    const {
        imageTransform: { flipH, flipV },
    } = layer.data as IImageLayerProps;
    const { width, height } = getMainLayerRenderSize(layer);

    const imageInnerStyle: React.CSSProperties = {
        width,
        height,
        transformOrigin: 'center center',
    };

    const imageWrapStyle: React.CSSProperties = {
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    };

    const flipStyle: React.CSSProperties = {
        pointerEvents: 'none',
    };

    if (flipH) {
        flipStyle.transform = 'scaleX(-1) ';
    }

    if (flipV) {
        const ry180 = 'scaleY(-1)';
        flipStyle.transform = flipStyle.transform ? flipStyle.transform + ry180 : ry180;
    }

    const { id, left, top, rotate, parentId } = layer;

    return (
        <div
            className="layer-view disable-event"
            data-layer-type={layer.layerType}
            data-layer-id={id}
            data-layer-parent-id={parentId || ''}
            style={{
                ...layerStyle,
                width,
                height,
                transform: `translate(${left}px, ${top}px) rotate(${rotate}deg)`,
            }}
        >
            <div className="layer-view__content" style={contentStyle}>
                <div style={imageWrapStyle}>
                    <div style={flipStyle}>
                        <div style={imageInnerStyle}>{children}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
